import { apiClient } from "./apiClient";

export interface MetaColetiva {
  id: number;
  lojaId: number;
  inicializacaoNota: number;
  producaoNota: number;
  finalizacaoNota: number;
  tempoMeta: string;
  tempoReal: string;
  errosProducao: number;
  metaAtingida: number;
  observacao?: string;
  createdAt: string;
  loja?: {
    id: number;
    nome: string;
  };
}

export interface MetaColetivaData {
  lojaId: number;
  inicializacaoNota: number;
  producaoNota: number;
  finalizacaoNota: number;
  tempoMeta: string;
  tempoReal: string;
  errosProducao: number;
  metaAtingida: number;
  observacao?: string;
}

export interface MetaColetivaFilters {
  page?: number;
  limit?: number;
  lojaId?: number | null;
}

export interface PaginatedMetaColetivaResponse {
  data: MetaColetiva[];
  total: number;
  totalPages: number;
  page: number;
  limit: number;
}

export const metaColetivaService = {
  getMetasColetivas: async (
    filters?: MetaColetivaFilters
  ): Promise<PaginatedMetaColetivaResponse> => {
    const params = new URLSearchParams();
    if (filters?.page != null) params.append("page", filters.page.toString());
    if (filters?.limit != null)
      params.append("limit", filters.limit.toString());
    if (filters?.lojaId != null)
      params.append("lojaId", filters.lojaId.toString());
    const query = params.toString();
    return apiClient.get<PaginatedMetaColetivaResponse>(
      `/metas-gerais-diarias${query ? `?${query}` : ""}`
    );
  },

  createMetaColetiva: async (data: MetaColetivaData): Promise<MetaColetiva> => {
    return apiClient.post<MetaColetiva>("/metas-gerais-diarias", data);
  },

  updateMetaColetiva: async (
    id: number,
    data: MetaColetivaData
  ): Promise<MetaColetiva> => {
    return apiClient.put<MetaColetiva>(`/metas-gerais-diarias/${id}`, data);
  },

  deleteMetaColetiva: async (id: number): Promise<void> => {
    return apiClient.delete(`/metas-gerais-diarias/${id}`);
  },
};
